import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Card, Form, FormInstance, Select, Input, DatePicker, Space, Spin } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { isValidCNPJ } from 'cnpj-cpf-validator';

import { obterOrigens, obterTipoPenalidades } from "../../../services/apiAuxiliar";
import PessoaFisicaPenalidadeDocumento from "./PessoaFisicaPenalidadeDocumento"
import { IPenalidadePessoaFisica, IDocumentoPessoaFisicaPenalidade } from "./InterfacePessoaFisica";

import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { onlyNumbers, disabledDate, hasText } from "../../../utils/utilsFunctions";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";

import { NumericFormat } from 'react-number-format';
import { maskCnpj } from "../../../utils/maskFunctions";
import { ICargoConsulta } from "../../Mandato/Componentes/InterfaceMandato";
import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { consultarCnpj } from "../../../services/apiExternos";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { Constantes } from "../../../config/Contantes";

interface IProps {
  form: FormInstance<any>;
  penalidades: IPenalidadePessoaFisica[];
  setPenalidades: React.Dispatch<React.SetStateAction<IPenalidadePessoaFisica[]>>;
  cargos: ICargoConsulta[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

enum TipoCargo {
  //Há enum equivalente no backend
 	DIRIGENTE = 1,
  DIRIGENTE_EXCEPCIONAL = 3,
  OUTRO_CARGO = 5
}

const { Option } = Select;
const { TextArea } = Input;

const PessoaFisicaPenalidade = ({ form, penalidades, setPenalidades, cargos, manter }: IProps) => {
  const separadorCargo = "|";

  const [pessoaFisicaPenalidadeDocumentos, setPessoaFisicaPenalidadeDocumentos] = useState<IDocumentoPessoaFisicaPenalidade[]>([]);

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalPen, setExibirModalPen] = useState(false);
  const [exibirPessoaFisicaPenalidadeCadastrada, setExibirPessoaFisicaPenalidadeCadastrada] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("none");
  const [dadosValidados, setDadosValidados] = useState(false);

  const [isRazaoSocialDisabled, setIsRazaoSocialDisabled] = useState(true);
  const [penalidadeStatusReg, setPenalidadeStatusReg] = useState(1); // ESTA VARIÁVEL CONTROLA TÃO SOMENTE A EXIBIÇÃO DO MODAL. StatusReg: 1) Registro ATUAL_ATIVO 2) Registro ATUAL_DELETADO

  const [matriculaEfpc, setMatriculaEfpc] = useState("");
  const [idCargoSelecionado, setIdCargoSelecionado] = useState(`${separadorCargo}${separadorCargo}`);

  const [entidades, setEntidades] = useState<IEntidade[]>([]);
  const [cargoMandatosPorEntidade, setCargoMandatosPorEntidade] = useState<ICargoConsulta[]>([]);
  const [msgMandatoAtivo, setMsgMandatoAtivo] = useState("");


  const [origens, setOrigens] = useState<any[]>([]);
  const getOrigens = async () => {
    await obterOrigens().then((response) => {
      setOrigens(response?.data);
    });
  };

  const [tipoPenalidades, setTipoPenalidades] = useState<any[]>([]);
  const getTipoPenalidades = async () => {
    await obterTipoPenalidades().then((response) => {
      setTipoPenalidades(response?.data);
    });
  };


  useEffect(() => {
    if (msgMandatoAtivo !== "") {
      mostrarInfo("Existe Cargo/Mandato ativo para Pessoa Física", msgMandatoAtivo);
      setMsgMandatoAtivo("");
    }
  }, [msgMandatoAtivo])

  useEffect(() => {
    if (penalidades && penalidades.length === 0) {
      setExibirPessoaFisicaPenalidadeCadastrada("none")
    } else {
      setExibirPessoaFisicaPenalidadeCadastrada("inline")
      setValoresAuxiliares();
    }
  }, [penalidades]);

  useEffect(() => {
    let cmEntidades: IEntidade[] = [];
    //console.log("cargoMandatos");
    //console.log(cargos);

    if (cargos && cargos.length > 0) {
      // PERCORRE OS CARGOS/MANDATOS E PREENCHE AS ENTIDADES
      cargos.forEach(cm => {
        // VERIFICA SE A ENTIDADE JÁ EXISTE
        if (cmEntidades.findIndex( (entidade) => cm.matricula === entidade.matricula ) === -1) {
          cmEntidades.push(cm);
        }
      });
    }
    cmEntidades.sort((a, b) => a.sigla > b.sigla ? 1 : -1);
    setEntidades(cmEntidades);
  }, [cargos]);

  useEffect(() => {
    if (!hasText(matriculaEfpc)) {
      // LIMPA OS DADOS DE ENTIDADE E CARGO/MANDATO
      form.resetFields([
        "sigla",
        "nmCargoMandato",
      ]);
      setIdCargoSelecionado(`${separadorCargo}${separadorCargo}`);

    } else {
      let cmsPorEntidade = cargos.filter(function (item) {
        return item.matricula === matriculaEfpc;
      });
      cmsPorEntidade.sort((a, b) => !a.dtInicio || !b.dtInicio || a.dtInicio > b.dtInicio ? 1 : -1);
      setCargoMandatosPorEntidade(cmsPorEntidade);
    }
  }, [matriculaEfpc]);

  const setValoresAuxiliares = (() => {
    penalidades.forEach(pen => {

      tipoPrazo.forEach(e => {
        if (pen.csTpPrazo === e.enum) {
          pen.tpPrazo = e.tpPrazo
        }
      });

    })

  });

  function liberarVisualizacao(){
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      //Tem que ter permissão de adicionar ou alterar penalidade
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DICOL_CGDC])){
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirElementoAcaoAlteracao("none");
      }
    }
  }

  useEffect(() => {
    liberarVisualizacao();

    if (origens.length === 0) getOrigens();
    if (getTipoPenalidades.length === 0) getTipoPenalidades();

  }, [manter]);

  useEffect(() => {
    liberarVisualizacao();
  }, []);


  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal])

  function makeKeyComboCargo(e:ICargoConsulta){
    return `${e.idMandato||''}${separadorCargo}${e.idDirExcepcional||''}${separadorCargo}${e.idOutroCargo||''}`;
  }
  function makeKeyCargo(idCargo?:number, tipoCargo?:number){
    switch (tipoCargo){
      case TipoCargo.DIRIGENTE:
        return `${idCargo}${separadorCargo}${separadorCargo}`;
      case TipoCargo.DIRIGENTE_EXCEPCIONAL:
        return `${separadorCargo}${idCargo}${separadorCargo}`;
      case TipoCargo.OUTRO_CARGO:
        return `${separadorCargo}${separadorCargo}${idCargo}`;
    }
    return `${separadorCargo}${separadorCargo}`;
  }
  function verificarCargoPreenchido(cargo:string){
    return cargo && onlyNumbers(cargo).length > 0;
  }


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir nova Penalidade", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalPen(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalPen(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "fechar") {
        setExibirModalPen(false);
        setExibirElementoAcaoAlteracao("none");
      } else {
        setExibirModalPen(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
  };

  const verificaMandatoAtivo = () => {
    cargos.forEach(cm => {
      if (cm.situacaoVigencia) {
        let nome = "???";
        if (cm.idMandato){
          nome = (cm.csCategoria === 1 ? "Diretor-Executivo" : "Conselheiro");
        } else if (cm.idDirExcepcional){
          nome = cm.nmCargoMandato;
        } else if (cm.idOutroCargo){
          nome = "Cargo "+ cm.nmCargoMandato;
        }
        const msgLocal = "Cargo/Mandato: " + nome + " - Entidade: " + cm.sigla + " - Período: " + dayjs(cm.dtInicio).format("DD/MM/YYYY") + " - " + (cm.dtFim ? dayjs(cm.dtFim).format("DD/MM/YYYY") : " ATÉ O MOMENTO");
        setMsgMandatoAtivo(msgLocal);
      }
    });
  };

  const validarPessoaFisicaPenalidade = () => {
    if ((hasText(matriculaEfpc) || verificarCargoPreenchido(idCargoSelecionado)) && Number(form?.getFieldValue("csOrigem")) === 2) {
      mostrarInfo("Entidade e Cargo/Mandato", "Para origem diferente de PREVIC/CRPC a entidade e o mandato não podem ser informados");
    } else if (pessoaFisicaPenalidadeDocumentos.length === 0) {
      mostrarInfo("Documentos", "Anexe pelo menos um documento.");
    } else {
      form
        .validateFields([
          "idPessoaFisicaPenalidade",
          "csOrigem",
          "origem",
          "csPenalidade",
          "penalidade",
          "dtInicio",
          "dtFim",
          "dtPublicacao",
          "nuCnpj",
          "nuPrazo",
          "csTpPrazo",
          "tpPrazo",
          "nuProcesso",
          "teFundamentacao",
          "teJustificativa",
          "vlPenalidade",
          "sigla",
          "nmCargoMandato",
        ])
        .then(() => {
          setDadosValidados(true);
          controleDaGrid("incluir");
          setDadosPessoaFisicaPenalidade();
        })
        .catch((error) => {
          if (!dadosValidados) {
            errorMessage("Campo obrigatório não preechido ou não validado");
          } else {
            errorMessage(error.message);
          }
          setDadosValidados(false);
        });
    }
  };

  const setDadosPessoaFisicaPenalidade = () => {
    let chaves = idCargoSelecionado.split(separadorCargo);
    let strIdMandato = chaves[0];
    let strExcepcional = chaves[1];
    let strOutroCargo = chaves[2];
    let idDoCargo:number|undefined = undefined;
    let tipoCargo:number|undefined = undefined;
    if (strIdMandato.length > 0){
      idDoCargo = Number(strIdMandato);
      tipoCargo = TipoCargo.DIRIGENTE;
    }
    else if (strExcepcional.length > 0){
      idDoCargo = Number(strExcepcional);
      tipoCargo = TipoCargo.DIRIGENTE_EXCEPCIONAL;
    }
    else if (strOutroCargo.length > 0){
      idDoCargo = Number(strOutroCargo);
      tipoCargo = TipoCargo.OUTRO_CARGO;
    }

    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setPenalidades(pre => {
        return pre.map(pfp => {
          if (pfp.emEdicao) {
            return ({
              idPessoaFisicaPenalidade: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaPenalidade")) : -1,
              csOrigem: Number(form?.getFieldValue("csOrigem")),
              origem: form?.getFieldValue("origem")?.toUpperCase(),
              csPenalidade: Number(form?.getFieldValue("csPenalidade")),
              penalidade: form?.getFieldValue("penalidade")?.toUpperCase(),
              dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
              dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
              dtPublicacao: form?.getFieldValue("dtPublicacao") ? dayjs(form?.getFieldValue("dtPublicacao")).format("YYYY-MM-DD") : "",
              nuCnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
              nuPrazo: Number(form?.getFieldValue("nuPrazo")),
              csTpPrazo: Number(form?.getFieldValue("csTpPrazo")),
              tpPrazo: form?.getFieldValue("tpPrazo")?.toUpperCase(),
              nuProcesso: onlyNumbers(form?.getFieldValue("nuProcesso")),
              teFundamentacao: form?.getFieldValue("teFundamentacao")?.toUpperCase(),
              teJustificativa: form?.getFieldValue("teJustificativa")?.toUpperCase(),
              vlPenalidade: form?.getFieldValue("vlPenalidade") ? Number(form?.getFieldValue("vlPenalidade").replace(".", "").replace(",", ".").replace(/[^0-9.-]+/g, "")) : 0,
              idCargo: idDoCargo,
              tipoCargo: tipoCargo,
              matriculaEfpc: matriculaEfpc,
              documentos: pessoaFisicaPenalidadeDocumentos.map((e: IDocumentoPessoaFisicaPenalidade) => {
                return {
                  ...e
                };
              }),
              statusReg: penalidadeStatusReg,
              touched: true,
              emEdicao: false,
            })
          } else {
            return pfp
          }
        })
      });
    } else {
      setPenalidades([
        ...penalidades,
        {
          idPessoaFisicaPenalidade: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaPenalidade")) : -1,
          csOrigem: Number(form?.getFieldValue("csOrigem")),
          origem: form?.getFieldValue("origem")?.toUpperCase(),
          csPenalidade: Number(form?.getFieldValue("csPenalidade")),
          penalidade: form?.getFieldValue("penalidade")?.toUpperCase(),
          dtInicio: form?.getFieldValue("dtInicio") ? dayjs(form?.getFieldValue("dtInicio")).format("YYYY-MM-DD") : "",
          dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
          dtPublicacao: form?.getFieldValue("dtPublicacao") ? dayjs(form?.getFieldValue("dtPublicacao")).format("YYYY-MM-DD") : "",
          nuCnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
          nuPrazo: Number(form?.getFieldValue("nuPrazo")),
          csTpPrazo: Number(form?.getFieldValue("csTpPrazo")),
          tpPrazo: form?.getFieldValue("tpPrazo")?.toUpperCase(),
          nuProcesso: onlyNumbers(form?.getFieldValue("nuProcesso")),
          teFundamentacao: form?.getFieldValue("teFundamentacao")?.toUpperCase(),
          // teJustificativa: form?.getFieldValue("teJustificativa")?.toUpperCase(),
          vlPenalidade: form?.getFieldValue("vlPenalidade") ? Number(form?.getFieldValue("vlPenalidade").replace(".", "").replace(",", ".").replace(/[^0-9.-]+/g, "")) : 0,
          idCargo: idDoCargo,
          tipoCargo: tipoCargo,
          matriculaEfpc: matriculaEfpc,
          documentos: pessoaFisicaPenalidadeDocumentos.map((e: IDocumentoPessoaFisicaPenalidade) => {
            return {
              ...e
            };
          }),
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);

    }
    limpaDados();
    setPenalidadeStatusReg(1); // VOLTA AO ESTADO INICIAL
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idPessoaFisicaPenalidade",
      "csOrigem",
      "origem",
      "csPenalidade",
      "penalidade",
      "dtInicio",
      "dtFim",
      "dtPublicacao",
      "nuCnpj",
      "nuPrazo",
      "csTpPrazo",
      "tpPrazo",
      "nuProcesso",
      "teFundamentacao",
      "teJustificativa",
      "vlPenalidade",
    ]);
    setDadosReceitaCnpjAsString("");
    setPessoaFisicaPenalidadeDocumentos([]);
  }

  const setFieldsDetalharEditar = (obPessoaFisicaPenalidade: IPenalidadePessoaFisica) => {
    form.setFieldsValue({
      "idPessoaFisicaPenalidade": obPessoaFisicaPenalidade.idPessoaFisicaPenalidade,
      "csOrigem": obPessoaFisicaPenalidade.csOrigem,
      "origem": obPessoaFisicaPenalidade.origem,
      "csPenalidade": obPessoaFisicaPenalidade.csPenalidade,
      "penalidade": obPessoaFisicaPenalidade.penalidade,
      "dtInicio": obPessoaFisicaPenalidade.dtInicio ? dayjs(obPessoaFisicaPenalidade.dtInicio) : undefined,
      "dtFim": obPessoaFisicaPenalidade.dtFim ? dayjs(obPessoaFisicaPenalidade.dtFim) : undefined,
      "dtPublicacao": obPessoaFisicaPenalidade.dtPublicacao ? dayjs(obPessoaFisicaPenalidade.dtPublicacao) : undefined,
      "nuCnpj": obPessoaFisicaPenalidade.nuCnpj ? maskCnpj(obPessoaFisicaPenalidade.nuCnpj) : undefined,
      "nuPrazo": obPessoaFisicaPenalidade.nuPrazo,
      "csTpPrazo": obPessoaFisicaPenalidade.csTpPrazo,
      "tpPrazo": obPessoaFisicaPenalidade.tpPrazo,
      "nuProcesso": obPessoaFisicaPenalidade.nuProcesso ? maskNumeroProcesso(obPessoaFisicaPenalidade.nuProcesso) : undefined,
      "teFundamentacao": obPessoaFisicaPenalidade.teFundamentacao,
      "teJustificativa": obPessoaFisicaPenalidade.teJustificativa,
      "vlPenalidade": obPessoaFisicaPenalidade.vlPenalidade?.toString().replace(".", ","),
      //      "idCargo": obPessoaFisicaPenalidade.idCargo,
    });
    
    setIdCargoSelecionado(obPessoaFisicaPenalidade.idCargo ? makeKeyCargo(obPessoaFisicaPenalidade.idCargo, obPessoaFisicaPenalidade.tipoCargo) : `${separadorCargo}${separadorCargo}`);

    if (obPessoaFisicaPenalidade.nuCnpj) {
      if (obPessoaFisicaPenalidade.csOrigem === 1) { // PREVIC/CRPC
        form.setFieldsValue({
          "nmRazaoSocial": "SUPERINTENDENCIA NACIONAL DE PREVIDENCIA COMPLEMENTAR",
        });
        setDisableOrigem(true);
      } else {
        form.setFieldsValue({
          "nmRazaoSocial": getCnpj(obPessoaFisicaPenalidade.nuCnpj)
        });

        // LIMPA OS DADOS DE ENTIDADE
        setMatriculaEfpc("");
      }
    }

    if (obPessoaFisicaPenalidade.documentos?.map) {
      let docs = obPessoaFisicaPenalidade.documentos.map((doc, i) => {
        return {
          idPessoaFisicaPenalidadeDocumento: doc.idPessoaFisicaPenalidadeDocumento,
          nmDocumento: doc.nmDocumento,
          nuDocumento: doc.nuDocumento,
          dtDocumento: doc.dtDocumento,
          docJustificativa: doc.docJustificativa,
          idDocumento: doc.idDocumento,
          documentoChave: doc.documentoChave,
          statusReg: 1,
          touched: true,
        }
      });
      setPessoaFisicaPenalidadeDocumentos(docs);
    }
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Processo",
      dataIndex: "",
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => <>{IPessoaFisicaPenalidade.nuProcesso ? maskNumeroProcesso(IPessoaFisicaPenalidade.nuProcesso) : ""}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Penalidade",
      dataIndex: "",
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => <>{IPessoaFisicaPenalidade.penalidade ? IPessoaFisicaPenalidade.penalidade : ""}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Origem",
      dataIndex: "",
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => <>{IPessoaFisicaPenalidade.origem}</>
    },
    {
      // width: 200,
      key: "4",
      title: "Data Publicação",
      dataIndex: "",
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => <> {IPessoaFisicaPenalidade.dtPublicacao ? dayjs(IPessoaFisicaPenalidade.dtPublicacao).format("DD/MM/YYYY") : ""}</>,
    },
    {
      // width: 200,
      key: "5",
      title: "Situação",
      dataIndex: "",
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => <> {IPessoaFisicaPenalidade.statusReg !== undefined && IPessoaFisicaPenalidade.statusReg === 1 ? "ATIVA" : "INATIVA"}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IPessoaFisicaPenalidade: IPenalidadePessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setPenalidadeStatusReg(IPessoaFisicaPenalidade?.statusReg !== undefined ? IPessoaFisicaPenalidade?.statusReg : 1);
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IPessoaFisicaPenalidade);
                }}
              />
            </div>

            <div style={{ display: IPessoaFisicaPenalidade.statusReg !== undefined && IPessoaFisicaPenalidade.statusReg !== 1 ? "none" : (manter === 1 ? "inline" : exibirElementoAcaoAlteracao) }}>
              <EditOutlined
                title={"Editar"}
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setPenalidadeStatusReg(IPessoaFisicaPenalidade?.statusReg !== undefined ? IPessoaFisicaPenalidade?.statusReg : 1);
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IPessoaFisicaPenalidade);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  penalidades.forEach(pen => {
                    if (pen === IPessoaFisicaPenalidade) {
                      pen.statusReg = IPessoaFisicaPenalidade?.statusReg !== undefined ? IPessoaFisicaPenalidade?.statusReg : 1;
                      pen.touched = true;
                      pen.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      pen.emEdicao = false;
                    }
                  })
                  IPessoaFisicaPenalidade.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir Penalidade não salva na base"
                style={{ color: "red", display: (IPessoaFisicaPenalidade?.idPessoaFisicaPenalidade && IPessoaFisicaPenalidade?.idPessoaFisicaPenalidade < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setPenalidades(penalidades.filter((penalidade) => penalidade !== IPessoaFisicaPenalidade));
                }}
              />
            </div>

            <div style={{ display: (IPessoaFisicaPenalidade?.idPessoaFisicaPenalidade && IPessoaFisicaPenalidade?.idPessoaFisicaPenalidade > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <DeleteOutlined
                  title="Excluir Penalidade já salva na base"
                  style={{ color: "red", display: (IPessoaFisicaPenalidade?.statusReg === 1 || IPessoaFisicaPenalidade?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    setPenalidadeStatusReg(2);
                    setEstadoModal(3); // SET O MODO EDIÇÃO
                    setFieldsDetalharEditar(IPessoaFisicaPenalidade);
                    // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                    penalidades.forEach(pen => {
                      if (pen === IPessoaFisicaPenalidade) {
                        pen.statusReg = IPessoaFisicaPenalidade?.statusReg !== undefined ? IPessoaFisicaPenalidade?.statusReg : 1;  // DEPOIS, AO CONFIRMAR O MODAL (OK) ativo SERÁ false.
                        pen.touched = true;
                        pen.emEdicao = estadoModal === 3 ? true : false;
                      } else {
                        pen.emEdicao = false;
                      }
                    })
                    IPessoaFisicaPenalidade.emEdicao = true;
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },

  ];

  const [dadosReceitaCnpjAsString, setDadosReceitaCnpjAsString] = useState("");
  const [disableOrigem, setDisableOrigem] = useState(false);

  async function getCnpj(nuCnpj: string) {
    if (isValidCNPJ(nuCnpj)) {
      setTipLoading("Buscando dados do CNPJ ...");
      setLoading(true);

      await consultarCnpj(nuCnpj).then((response) => {

        setDadosReceitaCnpjAsString(JSON.stringify(response.data)); // TRANSFORMA DTO EM STRING.
        form.setFieldsValue({
          "nmRazaoSocial": response.data?.nomeEmpresarial ? response.data?.nomeEmpresarial.toUpperCase() : undefined,
          "nmFantasia": response.data?.nomeFantasia ? response.data?.nomeFantasia.toUpperCase() : undefined,
        });

        if (form.getFieldValue("nmRazaoSocial") === "") setIsRazaoSocialDisabled(false);

        setLoading(false);
      })
        .catch((error) => {
          setLoading(false);
          mostrarInfo("Erro de acesso à API de CNPJ", "Não foi possível acessar a API de localização de CNPJ. Tente novamente mais tarde, por favor. Se o erro persisiter, entre em contato com o suporte (" + error.message + ").");
        })
    }
  }

  const maskCnpjChange = async (isValue: any) => {
    isValue = maskCnpj(isValue);
    form.setFieldsValue({
      nuCnpj: isValue,
    });
  };

  // Executado ao sair do campo CNPJ
  const handleNuCnpjInputBlur = (nuCnpj: string) => {
    if (isValidCNPJ(nuCnpj)) {
      nuCnpj = nuCnpj.replace(/\D/g, ""); //Remove tudo o que não é dígito
      getCnpj(nuCnpj);
    } else {
      form.setFieldsValue({
        "nuCnpj": undefined,
        "nmRazaoSocial": undefined,
      })
      errorMessage("Não foi possível coletar informações sobre o CNPJ informado. Verifique se o CNPJ está correto.");
    }
  };

  const handlerOrigem = async (value: any) => {
    if (value.value === 1) { // PREVIC/CRPC
      form.setFieldsValue({
        "nmRazaoSocial": "SUPERINTENDENCIA NACIONAL DE PREVIDENCIA COMPLEMENTAR",
        "nuCnpj": maskCnpj(Constantes.CNPJ_PREVIC),
        "origem": value.children,
        "csOrigem": value.key,
      });
      setDisableOrigem(true);
    } else {
      form.resetFields([
        "nmRazaoSocial",
        "nuCnpj",
      ]);

      form.setFieldsValue({
        "origem": value.children,
        "csOrigem": value.key,
      })
      setDisableOrigem(false);

      setMatriculaEfpc("");
    }
  };

  const handlePenalidade = async (value: any) => {
    form.setFieldsValue({
      "penalidade": value.children,
      "csPenalidade": value.key,
      "vlPenalidade": "",
      "dtInicio": undefined,
      "dtFim": undefined,
      "nuPrazo": "",
      "tpPrazo": undefined,
    })

    handleTpPrazoAutomatico(Number(value.key));
    setCampoDisabled(Number(value.key));
    setCampoRequired(Number(value.key));
  };

  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      sigla: value.children,
      matricula: value.key,
    });
    setMatriculaEfpc(value.key);
  };



  const handlerCargoMandato = async (value: any) => {
    form.setFieldsValue({
      nmCargoMandato: value.children,
    });
    setIdCargoSelecionado(value.key);
  };

  const handlerTpPrazo = async (value: any) => {
    form.setFieldsValue({
      "tpPrazo": value.children,
      "csTpPrazo": value.key,
    })
  };

  // const handlerVlPenalidade = async (value: any) => {
  //   form.setFieldsValue({
  //     "vlPenalidade": value.value,
  //   })
  // };


  const handleCancel = (botao: string) => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    setPenalidadeStatusReg(1); // VOLTA AO ESTADO INICIAL
    controleDaGrid(botao);
    form.resetFields([
      "idPessoaFisicaPenalidade",
      "csOrigem",
      "origem",
      "csPenalidade",
      "penalidade",
      "dtInicio",
      "dtFim",
      "dtPublicacao",
      "nuCnpj",
      "nmRazaoSocial",
      "nuPrazo",
      "csTpPrazo",
      "tpPrazo",
      "nuProcesso",
      "teFundamentacao",
      "teJustificativa",
      "vlPenalidade",
    ]);
  };

  // VERIFICA SE O CAMPO É OBRIGATÓRIO (valor, dtInicio, dtFim, prazo, tpPrazo)
  // VERIFICA SE O CAMPO É HABILITADO PARA EDIÇÃO (valor, dtInicio, dtFim, prazo, tpPrazo)
  const [isVlPenalidadeRequired, setIsVlPenalidadeRequired] = useState(false);
  const [isDtInicioRequired, setIsDtInicioRequired] = useState(false);
  const [isPrazoRequired, setIsPrazoRequired] = useState(false);
  const [isDtFimRequired, setIsDtFimRequired] = useState(false);
  const [isTpPrazoRequired, setIsTpPrazoRequired] = useState(false);

  const setCampoRequired = (csPenalidade: number) => {
    let isRequired = false;
    camposPorTipoPenalidade.forEach(tpPen => {
      if (tpPen.csPenalidade === csPenalidade) {
        setIsVlPenalidadeRequired(tpPen.valor > 0);
        setIsDtInicioRequired(tpPen.dtInicio > 0);
        setIsPrazoRequired(tpPen.prazo > 0);
        setIsDtFimRequired(tpPen.dtFim > 1);
        setIsTpPrazoRequired(tpPen.tpPrazo > 0);
      }
    });
    return isRequired;
  };

  // VERIFICA SE O CAMPO É HABILITADO PARA EDIÇÃO (valor, dtInicio, dtFim, prazo, tpPrazo)
  const [isVlPenalidadeDisabled, setIsVlPenalidadeDisabled] = useState(true);
  const [isDtInicioDisabled, setIsDtInicioDisabled] = useState(true);
  const [isPrazoDisabled, setIsPrazoDisabled] = useState(true);
  const [isDtFimDisabled, setIsDtFimDisabled] = useState(true);
  const [isTpPrazoDisabled, setIsTpPrazoDisabled] = useState(true);

  const setCampoDisabled = (csPenalidade: number) => {
    camposPorTipoPenalidade.forEach(tpPen => {
      if (tpPen.csPenalidade === csPenalidade) {
        setIsVlPenalidadeDisabled(tpPen.valor <= 1);
        setIsDtInicioDisabled(tpPen.dtInicio <= 1);
        setIsPrazoDisabled(tpPen.prazo <= 1);
        setIsDtFimDisabled(tpPen.dtFim <= 1);
        setIsTpPrazoDisabled(tpPen.tpPrazo <= 10);
      }
    });
  };

  // VERIFICA SE O tpPrazo TEM VALOR AUTOMÁTICO
  const handleTpPrazoAutomatico = (csPenalidade: number) => {
    camposPorTipoPenalidade.forEach(tpPen => {
      if (tpPen.csPenalidade === csPenalidade) {
        if (tpPen.tpPrazo > 0 && tpPen.tpPrazo <= 10) {
          form.setFieldsValue({
            "csTpPrazo": tpPen.tpPrazo,
            "tpPrazo": getTpPrazo(tpPen.tpPrazo),
          });
        } else if (tpPen.tpPrazo === 0) {
          form.setFieldsValue({
            "csTpPrazo": undefined,
            "tpPrazo": undefined,
          });
        }
      }
    });
  };

  function getTpPrazo(csTpPrazo: number) {
    let tpPrazo = "";
    tipoPrazo.forEach(e => {
      if (csTpPrazo === e.enum) {
        tpPrazo = e.tpPrazo
      }
    });
    return tpPrazo;
  }


  // VERIFICA SE A dtFim TEM VALOR AUTOMÁTICO
  const handleDtFim = (csPenalidade: number, csTpPrazo: number) => {
    camposPorTipoPenalidade.forEach(tpPen => {
      if (tpPen.csPenalidade === csPenalidade) {
        if (tpPen.dtFim === 1) {
          const nuPrazo = Number(form.getFieldValue("nuPrazo"));
          const d = dayjs(form?.getFieldValue("dtInicio"));

          let dtFim;
          if (csTpPrazo === 1) dtFim = d.add(nuPrazo, 'd');
          if (csTpPrazo === 2) dtFim = d.add(nuPrazo, 'w');
          if (csTpPrazo === 3) dtFim = d.add(nuPrazo, 'M');
          if (csTpPrazo === 4) dtFim = d.add(nuPrazo, 'y');

          form.setFieldsValue({
            "dtFim": dtFim
          });
        }

      }
    });
  };

  const maskPrazo = async (isValue: any) => {
    isValue = isValue + "";
    isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
    form.setFieldsValue({
      "nuPrazo": isValue,
    });
    handleDtFim(form.getFieldValue("penalidade"), form.getFieldValue("csTpPrazo"));
  };

  // Campos valor, dtInicio, dtFim, prazo : 0 => sem preenchimento e inibido / 1 => preenchimento automático e inibido / 2 =>  preenchimento manual obrigatório / 3 => preenchimento manual opcional
  // Campo tpPrazo: 0 => sem preenchimento e inibido / 1 => PRAZO EM DIAS - preenchimento automático e inibido / 2 => PRAZO EM SEMANA - preenchimento automático e inibido / 3 => PRAZO EM MESES - preenchimento automático e inibido / 4 => PRAZO EM ANOS - preenchimento automático e inibido / 11 =>  preenchimento manual obrigatório / 12 => preenchimento manual opcional
  let camposPorTipoPenalidade = [
    { "csPenalidade": 1, "valor": 0, "dtInicio": 0, "dtFim": 0, "prazo": 0, "tpPrazo": 0 },
    { "csPenalidade": 2, "valor": 0, "dtInicio": 2, "dtFim": 1, "prazo": 2, "tpPrazo": 1 },
    { "csPenalidade": 3, "valor": 0, "dtInicio": 2, "dtFim": 1, "prazo": 2, "tpPrazo": 4 },
    { "csPenalidade": 4, "valor": 2, "dtInicio": 0, "dtFim": 0, "prazo": 0, "tpPrazo": 0 },
    { "csPenalidade": 5, "valor": 2, "dtInicio": 0, "dtFim": 0, "prazo": 0, "tpPrazo": 0 },
    { "csPenalidade": 6, "valor": 2, "dtInicio": 2, "dtFim": 1, "prazo": 2, "tpPrazo": 1 },
    { "csPenalidade": 7, "valor": 2, "dtInicio": 2, "dtFim": 1, "prazo": 2, "tpPrazo": 4 },
    { "csPenalidade": 8, "valor": 0, "dtInicio": 0, "dtFim": 0, "prazo": 0, "tpPrazo": 0 },
  ];

  let tipoPrazo = [
    { "enum": 1, "tpPrazo": "Dias" },
    { "enum": 2, "tpPrazo": "Semanas" },
    { "enum": 3, "tpPrazo": "Meses" },
    { "enum": 4, "tpPrazo": "Anos" }
  ];


  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirPessoaFisicaPenalidade"
        type="primary"
        shape="round"
        onClick={() => {
          verificaMandatoAtivo();
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirPessoaFisicaPenalidade");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Penalidade
      </Button>

      <>
        <Modal title="Penalidades" open={exibirModalPen}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar"
              onClick={() => {
                if (estadoModal === 2) {
                  handleCancel("fechar");
                } else {
                  handleCancel("cancelar");
                }
              }}

            >
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarPessoaFisicaPenalidade}>
              {penalidadeStatusReg === 1 ? (estadoModal === 3 ? "Alterar" : "Incluir") : "Salvar"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Card title="Órgão Aplicador">
                <Row>
                  <Col xs={24} sm={10}>
                    <Form.Item label="Origem"
                      labelCol={{ span: 24 }}
                      name="origem"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O campo Origem é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Origem'
                        onChange={(_, index) => {
                          handlerOrigem(index);
                        }}
                        disabled={estadoModal === 2}
                      >
                        {origens?.map((e: any) => (
                          <Option key={e.valor} value={e.valor}>
                            {e.descricao}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={8}>
                    <Form.Item label='CNPJ'
                      labelCol={{ span: 24 }}
                      labelAlign="left"
                      name='nuCnpj'
                    >
                      <Input
                        value={form.getFieldValue("nuCnpj")}
                        onChange={(e) => maskCnpjChange(e.target.value)}
                        maxLength={18}
                        onBlur={(e) => handleNuCnpjInputBlur(e.target.value)}
                        disabled={estadoModal === 2 || disableOrigem}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={24}>
                    <Form.Item label='Razão Social'
                      labelCol={{ span: 24 }}
                      labelAlign="left"
                      name="nmRazaoSocial"
                    >
                      <Input disabled={isRazaoSocialDisabled} placeholder={"Razão Social"} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              <Card title="Dados da Penalidade">
                <Row>
                  <Col xs={24} sm={8}>
                    <Form.Item label='Número do Processo'
                      name='nuProcesso'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Digite um número válido",
                        },
                      ]}
                    >
                      <Input
                        disabled={manter === 2 || manter === 9 ? true : false}
                        onChange={(e) => {
                          form.setFieldsValue({
                            nuProcesso: maskNumeroProcesso(e.target.value)
                          })
                        }}
                        maxLength={20}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item label="Data da Publicação no DOU"
                      name="dtPublicacao"
                      colon={false}
                      style={{ flexDirection: "column", alignItems: "flex-start" }}
                      rules={[
                        {
                          required: true,
                          message: "Campo obrigatório",
                        },

                      ]}
                    >
                      <DatePicker
                        disabled={manter === 2 || manter === 9 ? true : false}
                        format={"DD/MM/YYYY"}
                        style={{ width: "100%" }}
                        placeholder="Selecionar Data"
                        disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </Col>

                </Row>

                <Row>
                  <Col xs={24} sm={10}>
                    <Form.Item label="Penalidade"
                      name="penalidade"
                      colon={false}
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "O campo Penalidade é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        // style={{ width: 50 }}
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Selecione a Penalidade'
                        onChange={(_, index) => {
                          handlePenalidade(index);
                        }}
                        disabled={estadoModal === 2}
                      >
                        {tipoPenalidades?.map((e: any) => (
                          <Option key={e.valor} value={e.valor}>
                            {e.descricao}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={8}>
                    <Form.Item label='Valor'
                      name='vlPenalidade'
                      labelCol={{ span: 24 }}
                      colon={false}
                      rules={[
                        {
                          required: isVlPenalidadeRequired,
                          message: "O campo valor é obrigatório",
                        },
                      ]}
                    >
                      <NumericFormat
                        thousandSeparator="."
                        prefix={'R$'}
                        decimalScale={2}
                        decimalSeparator=","
                        fixedDecimalScale
                        disabled={estadoModal === 2 || isVlPenalidadeDisabled}
                      // onValueChange={(value) => {
                      //   handlerVlPenalidade(value);
                      // }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={6}>
                    <Form.Item label="Data Início"
                      name="dtInicio"
                      colon={false}
                      rules={[
                        {
                          required: isDtInicioRequired,
                          message: "O campo data de início é obrigatório",
                        },
                      ]}
                    >
                      <DatePicker
                        format={"DD/MM/YYYY"}
                        style={{ width: "100%" }}
                        disabledDate={disabledDate}
                        placeholder="Selecionar Data"
                        disabled={estadoModal === 2 || isDtInicioDisabled}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={6}>
                    <Form.Item label="Periodicidade"
                      // labelCol={{ span: 6 }}
                      name="csTpPrazo"
                      colon={false}
                      rules={[
                        {
                          required: isTpPrazoRequired,
                          message: "O campo tipo de prazo é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Periodicidade'
                        onChange={(_, index) => {
                          handlerTpPrazo(index);
                        }}
                        disabled={estadoModal === 2 || isTpPrazoDisabled}
                      >
                        {tipoPrazo?.map((e: any) => (
                          <Option key={e.enum} value={e.enum}>
                            {e.tpPrazo}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={6}>
                    <Form.Item label='Prazo'
                      name='nuPrazo'
                      colon={false}
                      rules={[
                        {
                          required: isPrazoRequired,
                          message: "O campo prazo é obrigatório",
                        },
                      ]}
                    >
                      <Input
                        onChange={(e) => maskPrazo(e.target.value)}
                        // style={{
                        //   width: "100%",
                        // }}
                        maxLength={4}
                        placeholder='Prazo'
                        disabled={estadoModal === 2 || isPrazoDisabled}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={6}>
                    <Form.Item label="Data Fim"
                      name="dtFim"
                      colon={false}
                      rules={[
                        {
                          required: isDtFimRequired,
                          message: "O campo data fim é obrigatório",
                        },
                        {
                          validator: async (_, endDatetime) => {
                            let startDatetime = form.getFieldValue("dtInicio");
                            if (startDatetime) {
                              if (endDatetime <= startDatetime) {
                                return Promise.reject(
                                  "Data de fim deve ser maior do que a data de início"
                                );
                              }
                            }
                          },
                        },

                      ]}
                    >
                      <DatePicker
                        disabled={estadoModal === 2 || isDtFimDisabled}
                        format={"DD/MM/YYYY"}
                        style={{ width: "100%" }}
                        placeholder="Selecionar Data"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={24}>
                    <Form.Item label='Fundamentação Legal'
                      labelCol={{ span: 24 }}
                      name='teFundamentacao'
                    >
                      <TextArea rows={4}
                        placeholder='Fundamentação Legal'
                        disabled={estadoModal === 2}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} xl={12}>
                    <Form.Item label="Entidade"
                      labelCol={{ span: 24 }}
                      name="sigla"
                      colon={false}
                      rules={[
                        {
                          required: disableOrigem,
                          message: "A entidade é obrigatória",
                        },
                      ]}
                    >
                      <Select
                        disabled={estadoModal === 2 || !disableOrigem}
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Selecione a entidade'
                        onChange={(_, index) => {
                          handlerEntidade(index);
                        }}
                      >
                        {entidades?.map((e: IEntidade) => (
                          <Option key={e.matricula} value={e.sigla}>
                            {e.sigla}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={10}>
                    <Form.Item label="Cargo/Mandato"
                      labelCol={{ span: 24 }}
                      name="nmCargoMandato"
                      colon={false}
                      rules={[
                        {
                          required: disableOrigem,
                          message: "O mandato é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Cargo/Mandato'
                        onChange={(_, index) => {
                          handlerCargoMandato(index);
                        }}
                        disabled={estadoModal === 2 || !disableOrigem}
                      >
                        {cargoMandatosPorEntidade?.map((e: ICargoConsulta) => (
                          <Option key={makeKeyComboCargo(e)} value={e.nmCargoMandato + " - " + dayjs(e.dtInicio).format("DD/MM/YYYY") + " a " + (e.dtFim === undefined ? "-" : dayjs(e.dtFim).format("DD/MM/YYYY"))}>
                            {e.nmCargoMandato + " - " + dayjs(e.dtInicio).format("DD/MM/YYYY") + " a " + (e.dtFim === undefined ? "-" : dayjs(e.dtFim).format("DD/MM/YYYY"))}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              <Card title="Documentação" variant="borderless" style={{ width: "100%" }}>
                <>
                  <PessoaFisicaPenalidadeDocumento
                    documentos={pessoaFisicaPenalidadeDocumentos}
                    setDocumentos={setPessoaFisicaPenalidadeDocumentos}
                    form={form}
                    manter={manter}
                    docJustificativa={false}
                  />
                </>
              </Card>

              <Card title="Justificar a exclusão da Penalidade" hidden={penalidadeStatusReg === 1 ? true : false}>
                <Row>
                  <Col xs={24} sm={24}>
                    <Form.Item label='Justificativa'
                      labelCol={{ span: 24 }}
                      name='teJustificativa'
                      colon={false}
                      rules={[
                        {
                          required: penalidadeStatusReg === 1 ? false : true,
                          message: "A justificativa é obrigatória para exclusão de penalidade",
                        },
                      ]}                    >
                      <TextArea rows={4}
                        placeholder='Justificativa'
                        disabled={estadoModal === 2}
                      />
                    </Form.Item>
                  </Col>
                </Row>

              </Card>

              <Card title="Documentação da Justificativa" hidden={penalidadeStatusReg === 1 ? true : false} variant="borderless" style={{ width: "100%" }}>
                <>
                  <PessoaFisicaPenalidadeDocumento
                    documentos={pessoaFisicaPenalidadeDocumentos}
                    setDocumentos={setPessoaFisicaPenalidadeDocumentos}
                    form={form}
                    manter={manter}
                    docJustificativa={true}
                  />
                </>
              </Card>

            </>
          </Spin>
        </Modal>
      </>

      <Row style={{ display: exibirPessoaFisicaPenalidadeCadastrada }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={penalidades} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default PessoaFisicaPenalidade;